import {
  CITY_PREVIEW,
  CITY_NEW,
  CITY_UPDATE,
  CITY_REMOVE,
  CITY_PROCESS_SUCCESS,
  CITY_DATASOURCE_SUCCESS,
  CITY_SEARCH,
  CITY_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case CITY_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case CITY_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case CITY_UPDATE:{
        return{
          ...state,
          process:{status:false,action:"",message:""},
          loader:true
        }
    }
    case CITY_REMOVE: {
      return {
          ...state,
          loader: false
      }
    }
    case CITY_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case CITY_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:{...action.payload}
      }
    }
    case CITY_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case CITY_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}